import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface JobReportViewer {
    loading: boolean;
    reportFileName: string;
    data: any;
}
const win: any = window;
const Stimulsoft = win.Stimulsoft;

interface INameToValueMap {
    [key: string]: any;
}

export class JobReportViewerData extends React.Component<RouteComponentProps<{}>, JobReportViewer> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            reportFileName: "",
            data: {}
        };
    }

    componentDidMount() {
        //get the name of the report
        let userParams: INameToValueMap = {};
        userParams["name"] = "";
        userParams["id"] = 0;
        userParams["param1"] = 0;
        userParams = this.props.match.params;
        let reportName = userParams["name"];
        let jobId = userParams["id"];
        let param1 = userParams["param1"];

        if (reportName != "") {
            this.getData(jobId, reportName, param1);
        }
    }

    async getData(jobId: number, reportName: string, param1: number) {
        const token = await authService.getAccessToken();

        //get the data
        let url = "api/Report/Get" + reportName + "Data?jobId=" + jobId + "&reportName=" + reportName;
        if (param1 > 0) {
            url += "&param1=" + param1;
        }

        axios.get(url, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                this.setState({ reportFileName: res.data.reportFileName, data: res.data.reportData, loading: false });

                var viewer = new Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false);

                //console.log('Creating a new report instance');
                var report = new Stimulsoft.Report.StiReport();
                //report.loadFile("reports/" + res.data.reportFileName);
                var reportFile = Stimulsoft.System.IO.File.getFile("reports/" + res.data.reportFileName);
                report.load(reportFile);

                var reportData = JSON.stringify(res.data.reportData);
                //Dataset created
                var dataSet = new Stimulsoft.System.Data.DataSet("data");
                dataSet.readJson(reportData)
                report.regData(dataSet.dataSetName, "", dataSet);
                report.reportName = res.data.reportName;
                report.dictionary.connect(false);
                report.dictionary.synchronize();

                //add relationships between data
                for (var i = 0; i < res.data.reportRelationships.length; i++) {
                    var dataRelation = new Stimulsoft.Report.Dictionary.StiDataRelation(res.data.reportRelationships[i].sourceName, res.data.reportRelationships[i].name, res.data.reportRelationships[i].alias, report.dictionary.dataSources.getByName(res.data.reportRelationships[i].parentTableName), report.dictionary.dataSources.getByName(res.data.reportRelationships[i].childTableName), [res.data.reportRelationships[i].parentFieldName], [res.data.reportRelationships[i].childFieldName]);
                    report.dictionary.relations.add(dataRelation);
                    report.dictionary.synchronize();
                }

                viewer.report = report;
                viewer.renderHtml('viewer');
            }

        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div id="viewer"></div>
        )
    }

}
